import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "react-feather";
import "../styles/components/TermsAndConditions.css";

function TermsAndConditions() {
  const navigate = useNavigate();

  return (
    <div className="tc-page">
      <div className="tc-card">
        <div className="tc-header">
          <button className="tc-back-btn" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <div className="tc-title-block">
            <h2 className="tc-title">Terms & Conditions</h2>
            <p className="tc-subtitle">Please review our terms carefully</p>
          </div>
        </div>

        <div className="tc-content">
          <p className="tc-date">Last updated on May 28th 2025</p>
          <p className="tc-text">
            The Website Owner, including subsidiaries and affiliates ("Website"
            or "Website Owner" or "we" or "us" or "our") provides the
            information contained on the website or any of the pages comprising
            the website ("website") to visitors ("visitors") (cumulatively
            referred to as "you" or "your" hereinafter) subject to the terms and
            conditions set out in these website terms and conditions, the
            privacy policy and any other relevant terms and conditions, policies
            and notices which may be applicable to a specific section or module
            of the website.
          </p>
          <p className="tc-text">
            Welcome to our website. If you continue to browse and use this
            website you are agreeing to comply with and be bound by the
            following terms and conditions of use, which together with our
            privacy policy govern UEXCESS E COMMERCE PRIVATE LIMITED''s
            relationship with you in relation to this website.
          </p>
          <p className="tc-text">
            The term 'UEXCESS E COMMERCE PRIVATE LIMITED' or 'us' or 'we' refers
            to the owner of the website whose registered/operational office is
            NO927 13THCROSS, 4TH BLOCK HMT LAYOUT, Vidyaranyapura, Bangalore
            North, Bangalore- 560097, Karnataka. The term 'you' refers to the
            user or viewer of our website.
          </p>
          <p className="tc-text-bold">
            The use of this website is subject to the following terms of use:
          </p>

          <ul className="tc-list">
            <li className="tc-list-item">
              The content of the pages of this website is for your general
              information and use only. It is subject to change without notice.
            </li>
            <li className="tc-list-item">
              Neither we nor any third parties provide any warranty or guarantee
              as to the accuracy, timeliness, performance, completeness or
              suitability of the information and materials found or offered on
              this website for any particular purpose. You acknowledge that such
              information and materials may contain inaccuracies or errors and
              we expressly exclude liability for any such inaccuracies or errors
              to the fullest extent permitted by law.
            </li>
            <li className="tc-list-item">
              Your use of any information or materials on this website is
              entirely at your own risk, for which we shall not be liable. It
              shall be your own responsibility to ensure that any products,
              services or information available through this website meet your
              specific requirements.
            </li>
            <li className="tc-list-item">
              This website contains material which is owned by or licensed to
              us. This material includes, but is not limited to, the design,
              layout, look, appearance and graphics. Reproduction is prohibited
              other than in accordance with the copyright notice, which forms
              part of these terms and conditions.
            </li>
            <li className="tc-list-item">
              All trademarks reproduced in this website which are not the
              property of, or licensed to, the operator are acknowledged on the
              website.
            </li>
            <li className="tc-list-item">
              Unauthorized use of this website may give rise to a claim for
              damages and/or be a criminal offense.
            </li>
            <li className="tc-list-item">
              From time to time this website may also include links to other
              websites. These links are provided for your convenience to provide
              further information.
            </li>
            <li className="tc-list-item">
              You may not create a link to this website from another website or
              document without UEXCESS E COMMERCE PRIVATE LIMITED's prior
              written consent.
            </li>
            <li className="tc-list-item">
              Your use of this website and any dispute arising out of such use
              of the website is subject to the laws of India or other regulatory
              authority.
            </li>
            <li className="tc-list-item">
              No Return or Refund Policy: By using our website and subscribing
              to our app, you acknowledge that all payments made for
              subscriptions are non-refundable. Once a subscription is
              purchased, no returns or refunds will be provided.
            </li>
            <li className="tc-list-item">
              Payment Gateway: We utilize a secure payment gateway for all
              transactions. Your payment details are encrypted and processed
              securely. However, we recommend that you review the terms and
              conditions of the payment gateway provider as well.
            </li>
            <li className="tc-list-item">
              Shipping: We are a 3rd party where we just provide a platform for
              buyers and sellers so shipping is not applicable for us.
            </li>
            <li className="tc-list-item">
              Return & Refund: We do not offer any return or refunds for any of
              its products or services. All sales are final.
            </li>
            <li className="tc-list-item">
              Transactions should be conducted only in INR (Indian Rupees).
            </li>

            <li className="tc-list-item">
              Authorization Limits: As a merchant, we shall not be liable for
              any loss or damage arising directly or indirectly due to the
              decline of authorization for any transaction. This may occur if
              the cardholder exceeds the preset limit mutually agreed upon by us
              and our acquiring bank.
            </li>
          </ul>
          <p className="tc-text">
            We as a merchant shall be under no liability whatsoever in respect
            of any loss or damage arising directly or indirectly out of the
            decline of authorization for any Transaction, on Account of the
            Cardholder having exceeded the preset limit mutually agreed by us
            with our acquiring bank from time to time.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
